/** IcoMoon codepoints from rn-ticketack-mobile selection.json (fontFamily icomoon). */
export const EXPLORIT_GLYPH_CODES = {
    "account": 0xe913,
    "agenda": 0xe900,
    "back": 0xe901,
    "cart": 0xe917,
    "cinema": 0xe903,
    "delivery": 0xe904,
    "discounts": 0xe910,
    "edit": 0xe912,
    "events": 0xe905,
    "facebook": 0xe906,
    "fidelity": 0xe911,
    "history": 0xe907,
    "home": 0xe908,
    "house": 0xe93a,
    "info": 0xe909,
    "instagram": 0xe90a,
    "linkedin": 0xe90c,
    "logout": 0xe90d,
    "members": 0xe90e,
    "menu": 0xe90f,
    "news": 0xe916,
    "pass": 0xe914,
    "payment": 0xe915,
    "phone": 0xe918,
    "play": 0xe90b,
    "pricings": 0xe939,
    "profil_1": 0xe91a,
    "profil_2": 0xe91c,
    "profil_3": 0xe91e,
    "profil_4": 0xe920,
    "profil_family": 0xe922,
    "restaurants": 0xe930,
    "seat_booked_by_me": 0xe931,
    "seat_busy": 0xe934,
    "seat_free": 0xe937,
    "services": 0xe938,
    "settings": 0xe92f,
    "ticket": 0xe902,
    "wallet": 0xe919,
};

